<ng-container>
    <form [formGroup]="form" class="dynamic-form" *ngIf="config">
        <div class="row" *ngFor="let item of config">
          <div class="col pb-1" *ngIf="canShowDynamicControl(item)">
            <tsl-form-field class="w-50">
              <tsl-label>{{ translate.get(item.label) }}</tsl-label>
              <!-- Text Input -->
              <input *ngIf="item.type === 'text'" 
                     tslInput 
                     [type]="item.type"
                     [formControlName]="item.controlName">
              <!-- Dropdown -->
              <tsl-select *ngIf="item.type === 'dropdown'"
                         [formControlName]="item.controlName"
                         shape="round">
                <tsl-option *ngFor="let option of item.options" 
                           [value]="option.value">
                  {{ translate.get(option.label) }}
                </tsl-option>
              </tsl-select>
              <!-- Error Messages -->
              <tsl-error>
                <!-- Required Error -->
                <span *ngIf="form.get(item.controlName).hasError('required')">
                  {{ translate.get(item.validations.required.message) }}
                </span>
                <!-- Pattern Error -->
                <span *ngIf="form.get(item.controlName).hasError('pattern')">
                  {{ translate.get(item.validations.pattern.message) }}
                </span>
              </tsl-error>
            </tsl-form-field>
          </div>
        </div>

        <div class="question" style="margin-top: 10px;">
            <tsl-radio-group class="radio-group-example" formControlName="confirmControl">
                <tsl-radio-button value="true"><span i18n="@@iConfirm" t="iConfirm">I confirm that the above information is correct.</span></tsl-radio-button>
            </tsl-radio-group>
            <tsl-error *ngIf="confirmControl.hasError('required') && confirmControl.touched"
                class="text-left" i18n="@@434f8f6235a970107568236f8a35a307dddd13e0" t="434f8f6235a970107568236f8a35a307dddd13e0">
                This field is required.
            </tsl-error>
        </div>
      </form>
    <div class="row" *ngIf="requiredDocuments?.length>0 && isMSMEEligible" style="margin-top: 10px;">
        <div class="col-12">
            <documents-grid #msmeDocumentsGrid [tsl-supplierCode]="supplierCode" [tsl-documents]="requiredDocuments"
                [tsl-readOnly]="readOnly"></documents-grid>
        </div>
    </div>
</ng-container>

<!-- Save button -->
<div *ngIf="!hideSaveBtn" class="row">
    <div class="col text-right"><button color="blue" (click)="submit()" tsl-button>{{translate.get(saveButtonLabel)}}</button></div>
</div>

